export type NavigationItem = {
  id?: string | null
  navigationLabel?: string | null
}

export function getDatoCmsPctPageNavigationLabel(
  item: NavigationItem | null
): string {
  const navigationLabel: string =
    item != null && 'navigationLabel' in item && item.navigationLabel != null
      ? item.navigationLabel
      : ''

  return navigationLabel
}
